import React, { useState, useEffect } from 'react';
import { getContactsByUser, getContactGroupByUser,checkUserLimits } from '../components/DbServices';
import axios from 'axios';
import { whatsappapi } from '../api/api';
import { getStoredUser } from '../utilities/encryption';
import Swal from 'sweetalert2';

export default function SendMessageModal({ device, onClose }) {
  const user = getStoredUser();
  const userId = user?.data?.id;

  const [sendType, setSendType] = useState('individual');
  const [contacts, setContacts] = useState([]);
  const [groups, setGroups] = useState([]);
  
  const [selectedNumber, setSelectedNumber] = useState('');
  const [selectedGroupContacts, setSelectedGroupContacts] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  // Attachment States
  const [file, setFile] = useState(null);
  const [base64File, setBase64File] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      const cRes = await getContactsByUser({ id: userId });
      const allContacts = cRes.data || [];
      const activeContacts = allContacts.filter(c => Number(c.status) === 1);
      setContacts(activeContacts);
      
      // 2. Fetch and filter Groups
      const gRes = await getContactGroupByUser(userId);
      const allGroups = gRes.data || [];
      const activeGroups = allGroups.filter(g => Number(g.status) === 1);
      setGroups(activeGroups);
    };
    loadData();
  }, [userId]);

  // Convert file to Base64
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
  
    setFile(selectedFile);
    const reader = new FileReader();
    reader.onloadend = () => {
      // ⬇️ THIS IS THE CRITICAL LINE ⬇️
      // Split at the comma and take the second part (the actual data)
      const base64String = reader.result.split(',')[1]; 
      setBase64File(base64String);
    };
    reader.readAsDataURL(selectedFile);
  };

  // const handleSend = async () => {
  //   let recipients = [];

  //   let check=checkUserLimits(userId,'message')

  //   if(check.message=='Message balance exhausted')
  //   {
  //     return Swal.fire("You dont have enough message balance");
  //   }


  //   if (sendType === 'individual') {
  //     if (!selectedNumber) return Swal.fire("Select a contact");
  //     recipients = [selectedNumber];
  //   } else {
  //     if (selectedGroupContacts.length === 0) return Swal.fire("Select a group");
  //     recipients = selectedGroupContacts;
  //   }

  //   if (!message && !file) return Swal.fire("Please enter a message or attach a file");

  //   setLoading(true);
  //   try {
  //     for (const number of recipients) {
  //       const payload = {
  //         session_id: device.session_id,
  //         device_id: device.id,
  //         to: number,
  //         message: message,
  //         // Add attachment fields
  //         media: base64File ? base64File : null, 
  //         filename: file ? file.name : null
  //       };

  //       // Note: Check if your API endpoint changes for media (e.g., /message/send-media)
  //       await axios.post(`${whatsappapi}/message/send`, payload);

  //       await new Promise(resolve => setTimeout(resolve, 1500)); // Slightly longer delay for files
  //     }
  //     Swal.fire("Sent successfully!");
  //     onClose();
  //   } catch (err) {
  //     Swal.fire("Error: " + (err.response?.data?.error || "Connection failed"));
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSend = async () => {
    // 1. Identify Recipients first
    let recipients = [];
    if (sendType === 'individual') {
        if (!selectedNumber) return Swal.fire("Select a contact");
        recipients = [selectedNumber];
    } else {
        if (selectedGroupContacts.length === 0) return Swal.fire("Select a group");
        recipients = selectedGroupContacts;
    }

    if (!message && !file) return Swal.fire("Please enter a message or attach a file");

    setLoading(true);
    try {
        // 2. BACKEND CHECK: Check if the user has enough balance for ALL recipients
        // We pass the count to the backend so it can validate: (total_sent + recipients.length) <= limit
        const check = await checkUserLimits(userId, 'message'); 
        
        // Assuming checkUserLimits returns the actual current subscription stats
        const remaining = check.data.message_limit - check.data.messages_sent;

        if (recipients.length > remaining) {
            setLoading(false);
            return Swal.fire(`Insufficient balance. You want to send ${recipients.length} messages, but only have ${remaining} left.`);
        }

        debugger
        // 3. BROADCAST LOOP
        // for (const number of recipients) {
        //     const payload = {
        //         session_id: device.session_id,
        //         device_id: device.id,
        //         user_id: userId, // CRITICAL: Send userId so the backend knows who to bill
        //         to: number,
        //         message: message,
        //         media: base64File || null, 
        //         filename: file ? file.name : null,
        //         subscription_id:localStorage.getItem('subscription_id')
        //     };

        //     await axios.post(`${whatsappapi}/message/send`, payload);
            
        //     // Short delay to prevent WhatsApp banning/spam detection
        //     await new Promise(resolve => setTimeout(resolve, 1000)); 
        // }


        // 3. BROADCAST LOOP (Non-blocking)
// const startBroadcast = async () => {
//   for (const number of recipients) {
//       try {
//           const payload = {
//               session_id: device.session_id,
//               device_id: device.id,
//               user_id: userId,
//               to: number,
//               message: message,
//               media: base64File || null, 
//               filename: file ? file.name : null,
//               subscription_id: localStorage.getItem('subscription_id')
//           };

//           await axios.post(`${whatsappapi}/message/send`, payload);
//           console.log(`Sent to ${number}`);
//       } catch (e) {
//           console.error(`Failed to send to ${number}`, e);
//       }
      
//       // Delay remains here to protect your WhatsApp account
//       await new Promise(resolve => setTimeout(resolve, 1000)); 
//   }
// };


const startBroadcast = async () => {
  for (const number of recipients) {
    try {
      const payload = {
        session_id: device.session_id,
        device_id: device.id,
        user_id: userId,
        to: number,
        message: message,
        media: base64File || null,
        filename: file ? file.name : null,
        subscription_id: localStorage.getItem('subscription_id')
      };

      await axios.post(`${whatsappapi}/message/send`, payload);
      console.log(`Sent to ${number}`);
    } catch (e) {
      console.error(`Failed to send to ${number}`, e);
    }

    // ✅ Random delay between 1 to 10 seconds
    const randomDelay = Math.floor(Math.random() * 10000) + 1000; 
    // 1000ms (1s) → 10000ms (10s)

    console.log(`Waiting ${randomDelay / 1000}s before next message...`);

    await new Promise(resolve => setTimeout(resolve, randomDelay));
  }
};

// Trigger the loop but DO NOT use 'await' here
startBroadcast();

// 4. IMMEDIATE FEEDBACK
setLoading(false);
Swal.fire("Broadcast submitted successfully! Messages are being sent in the background.");
onClose();

        
    } catch (err) {
        Swal.fire("Error: " + (err.response?.data?.message || "Operation failed"));
    } finally {
        setLoading(false);
    }
};

  return (
    <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0">
          <div className="modal-header bg-light">
            <h5 className="fw-bold">Send Message & Media</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body p-4">
            
            {/* Type Toggle */}
            <div className="btn-group w-100 mb-3">
              <button className={`btn btn-sm ${sendType === 'individual' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setSendType('individual')}>Single</button>
              <button className={`btn btn-sm ${sendType === 'group' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setSendType('group')}>Group</button>
            </div>

            {/* Recipient Selection */}
            {sendType === 'individual' ? (
              <select className="form-select mb-3" onChange={(e) => setSelectedNumber(e.target.value)}>
                <option value="">Choose Contact...</option>
                {contacts.map(c => <option key={c.id} value={c.number}>{c.name}-({c.number})</option>)}
              </select>
            ) : (
              <select className="form-select mb-3" onChange={(e) => {
                try {
                  const ids = JSON.parse(e.target.value);
                  const nums = contacts.filter(c => ids.includes(String(c.id))).map(c => c.number);
                  setSelectedGroupContacts(nums);
                } catch(e) { setSelectedGroupContacts([]); }
              }}>
                <option value="">Choose Group...</option>
                {groups.map(g => <option key={g.id} value={g.contacts}>{g.groupname}</option>)}
              </select>
            )}

            {/* Message */}
            <label className="small fw-bold">Caption / Message</label>
            <textarea className="form-control mb-3" rows="3" value={message} onChange={e => setMessage(e.target.value)} />

            {/* File Attachment */}
            <label className="small fw-bold">Attachment (Image, PDF, etc.)</label>
            <input type="file" className="form-control mb-2" onChange={handleFileChange} />
            {file && <div className="text-muted x-small">Selected: {file.name} ({(file.size / 1024).toFixed(1)} KB)</div>}

          </div>
          <div className="modal-footer">
            <button className="btn btn-primary w-100" onClick={handleSend} disabled={loading}>
              {loading ? "Sending Broadcast..." : "Send Now"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}